// filepath: apps/web/src/features/promote/IrreversibilityCheckbox.tsx
//
// FR-UI-PROM-1 AC-4: explicit checkbox blocks approve until checked.
// The reviewer must actively acknowledge the irreversibility warning before
// the approve button becomes active.

import React from "react";

interface IrreversibilityCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

/**
 * Controlled checkbox that gates the approve action.
 * Disabled until the user explicitly checks the box.
 */
export function IrreversibilityCheckbox({
  checked,
  onChange,
  disabled,
}: IrreversibilityCheckboxProps): React.ReactElement {
  return (
    <label
      className={`flex items-start gap-2 text-sm ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        className="mt-0.5 h-4 w-4 rounded border-input text-destructive focus:ring-destructive"
        data-testid="irreversibility-checkbox"
        aria-describedby="irreversibility-checkbox-description"
      />
      <span id="irreversibility-checkbox-description">
        I acknowledge that this promotion contains irreversible field-promotion
        contract steps. Once the column-only placement is applied, it cannot be
        undone by pointer rollback.
      </span>
    </label>
  );
}
